import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/diarias/listar'


function ListarDiariasScreen() {

    return (
        <Fragment>
            <Head titulo="Tabela de Diárias concedidas aos servidores do Município de Macuco" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarDiariasScreen;